import { Component, Input, Output, OnInit, OnChanges, OnDestroy, EventEmitter, NgZone, SimpleChanges } from '@angular/core';

import { SelectItem } from '../models/form-field';
import { DataFile } from '../models/file-form-info';
import { ListData } from '../models/base';
import { ListItem } from '../models/list-item';
import { FileFormInfo } from '../models/file-form-info';
import { SecurityControl, AccessLevel } from '../models/security-control';
import { LocalizeService } from '../services/localize.service';
import { OOxmlService } from '../services/ooxml.service';
import { FormService } from './../services/form.service';
import { Util, UserInterface } from '../utils/utils.module';
import { SegmentComponent } from './segment.component';
import { AppComponent } from '../app.component';
import { UploadService } from '../services/upload.service';
import { MenuId } from '../services/menu.service';

declare let Office: any;
declare let Word: any;
const searchForTestDoc = false;

@Component({
  selector: 'edx-search-office',
  styleUrls: ['search-mobile.component.scss', 'search-office.component.scss'],
  template: `
    <div class="contentpanel oai" [ngClass]="{ieedge:ieEdge}" [edx-file-drop-target]="this">
      @if (!isOfficeAddinOutlookMessageEditable) {
        <div class="addinrow" id="edx_search_outlook">
          <div class="addinbar" [ngClass]="{alignmentfix:addEnabled}">
            <span class="icon-wrapper">
              <img class="headericon" src="{{addinItemIcon()}}" />
            </span>
            <div class="text wrap" title="{{addinItemTitle}}">{{addintemName()}}</div>
            <div class="addbtn">
              @if (showSaveButton()) {
                <button [ngClass]="{readonly:!addEnabled && !addinItem}" tabindex="0" (click)="saveButtonClicked($event)"
                  (keyup.enter)="saveButtonClicked($event)" (keydown.space)="saveButtonClicked($event)">{{saveButtonTitle()}}
                </button>
              }
            </div>
            @if (canShowSaveAsDmVersion()) {
              <div [ngClass]="{headermenu:ui<2, toucharea:ui>=2,right:ui>=2}">
                <edx-menu #menuDiv [id]= "'edx_header_menu'" [menuId]="'edx_header_menu'"
                  [ariaLabel]="this.localizer.getTranslation('ALT_TEXT.HEADER_MENU')"
                  [menuID]="headerMenuID" [callback]="this"
                  [hideIfEmpty]="true" [forceMenuButton]="ui>=2" [tabIndex]="0">
                </edx-menu>
              </div>
            }
          </div>
          <div class="finding" [ngClass]="{edx_hidden:headerCollapsed}">
            @if (!findingAddinItem && ((!!addinItemOptionItems || !isOfficeAddinOutlook) && !addinItem)) {
              <div class="text">{{this.localizer.getTranslation((!!addinItemAttachments || isOfficeAddinOutlook) ? 'FORMS.LOCAL.OAI_ADD.ADD_MSG' : 'FORMS.LOCAL.OAI_ADD.ADD_DOC_AS')}}</div>
              @if ((!!addinItemOptionItems || !isOfficeAddinOutlook)) {
                <edx-select id="edx_message_options" [items]="addinItemOptionItems" [value]="addinItemOption" [inDialog]="true" (change)="addinItemOptionChanged($event)" [tabIndex]="0"></edx-select>
              }
              @if (showAttachmentsSelectionList) {
                <edx-select [items]="msgAndAttachmentsList" id="edx_message_attachments_selections" [value]="msgAndAttachmentsSelection" [inDialog]="true" [isMultiSelect]="true" [showIcon]="true" (change)="attachmentSelectionChanged($event)"></edx-select>
              }
            }
            @if (findingAddinItem) {
              <div class="spincontainer">
                <edx-spinner [mini]="true"></edx-spinner>
              </div>
            }
          </div>
          @if (!findingAddinItem && !!addinItem) {
            <div class="addinrow list" [id]="getRowId(0)" tabindex="0" (click)="profileClick('profile')" (keyup)="onKeyUp($event,'profile',0)">
              <div class="icon profile"></div>
              <div class="text">{{this.localizer.getTranslation('METADATA.TABS.PROFILE')}}</div>
            </div>
            @if (canShowPreview()) {
              <div class="addinrow list" [id]="getRowId(1)" tabindex="0" (click)="profileClick('preview')" (keyup)="onKeyUp($event,'preview',1)">
                <div class="icon preview"></div>
                <div class="text">{{this.localizer.getTranslation('METADATA.TABS.PREVIEW')}}</div>
              </div>
            }
            @if (bravaEnabled) {
              <div class="addinrow list" [id]="getRowId(2)" tabindex="0" (click)="profileClick('viewer')" (keyup)="onKeyUp($event,'viewer',2)">
                <div class="icon preview"></div>
                <div class="text">{{this.localizer.getTranslation('METADATA.TABS.VIEWER')}}</div>
              </div>
            }
            <div class="addinrow list" tabindex="0" [id]="getRowId(3)" (click)="profileClick('versions')" (keyup)="onKeyUp($event,'versions',3)">
              <div class="icon versions"></div>
              <div class="text">{{this.localizer.getTranslation('METADATA.TABS.VERSIONS')}}</div>
            </div>
            <div class="addinrow list" tabindex="0" [id]="getRowId(4)" (click)="profileClick('history')" (keyup)="onKeyUp($event,'history',4)">
              <div class="icon history"></div>
              <div class="text">{{this.localizer.getTranslation('METADATA.TABS.HISTORY')}}</div>
            </div>
            <div class="addinrow list" tabindex="0" [id]="getRowId(5)" (click)="profileClick('whereused')" (keyup)="onKeyUp($event,'whereused',5)">
              <div class="icon whereused"></div>
              <div class="text">{{this.localizer.getTranslation('METADATA.TABS.WHERE_USED')}}</div>
            </div>
            <div class="addinrow list" tabindex="0" [id]="getRowId(6)" (click)="profileClick('related')" (keyup)="onKeyUp($event,'related',6)">
              <div class="icon whereused"></div>
              <div class="text">{{this.localizer.getTranslation('METADATA.TABS.RELATED')}}</div>
            </div>
            <div class="addinrow list" tabindex="0" [id]="getRowId(7)" (click)="profileClick('attachments')" (keyup)="onKeyUp($event,'attachments',7)">
              <div class="icon whereused"></div>
              <div class="text">{{this.localizer.getTranslation('METADATA.TABS.ATTACHMENTS')}}</div>
            </div>
            @if (canShowSecurity()) {
              <div class="addinrow list" tabindex="0" [id]="getRowId(8)" (click)="profileClick('security')" (keyup)="onKeyUp($event,'security',8)">
                <div class="icon security"></div>
                <div class="text">{{this.localizer.getTranslation('METADATA.TABS.SECURITY')}}</div>
              </div>
            }
          }
        </div>
      }
    </div>
    `,
  standalone: false
})
export class SearchOfficeComponent implements OnInit, OnChanges, OnDestroy {
  public isOfficeAddinOutlookMessageEditable: boolean;
  public dataFiles: DataFile[] = null;
  public formData: any = null;
  public trustees: any[] = null;
  public fileFormInfo: FileFormInfo = null;
  public ieEdge: boolean;
  public msgAndAttachmentsList: any[] = null;
  public desc: any;
  private app: AppComponent = Util.RestAPI.getAppComponent();
  private bravaEnabled: boolean;
  private isAddin: boolean;
  private isAcrobatPlugin: boolean;
  private isOfficeAddin: boolean;
  private isOfficeAddinOutlook: boolean;
  private findingAddinItem = false;
  private addinItem: ListItem = null;
  private addinItemFileName: string;
  private addinItemFilePath: string;
  private addinItemTitle: string;
  private addinItemVersionLabel: string;
  private addinItemExtension: string;
  private addinItemAttachments: any[] = null;
  private addinItemOption: string = null;
  private previousSelectedAddinItemOption: string = null;
  private addinItemOptionItems: SelectItem[] = null;
  private addinItemChangedEventID = 0;
  private officePropertiesError: any = null;
  private isSaveButtonClicked = false;
  private showAttachmentsSelectionList = false;
  private msgAndAttachmentsSelection: string;
  private ui: UserInterface = Util.Device.ui;
  private headerMenuID = MenuId.MENU_SAVE_NEW_DOCUMENT;

  @Output() addToDMClicked: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() gotOfficeDataFiles: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() descDataFilesChanging: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Input() addEnabled?: boolean = false;
  @Input() headerCollapsed?: boolean = false;
  @Input('docName') set setter(value: string) {
    if (!!value) {
      this.addinItemTitle = value;
      if (!!this.dataFiles && (Util.Device.bIsOfficeAddinExcel || Util.Device.bIsOfficeAddinPowerPoint)) {
        const fileNameParts = this.dataFiles[0].name.split('.');
        fileNameParts[0] = fileNameParts[0] || value;
        this.dataFiles[0].name = fileNameParts.join('.');
      }
    }
  }
  @Input('isUploadToEdocsClicked') set isUploadToEdocsClicked(value: boolean) {
    if (!this.desc) {
      this.desc = {};
    }
    if (!!this.desc) {
      const name = this.desc['name'] ?? this.addinItemTitle;
      if (value) {
        this.updateDesc(Util.RestAPI.getAppDesc());
        this.desc['name'] = name;
      } else {
        this.desc = { id: '0', lib: Util.RestAPI.getPrimaryLibrary(), type: 'documents', name: name };
      }
    }
  }

  constructor(public localizer: LocalizeService, protected zone: NgZone, private ooxmlService: OOxmlService, private formService: FormService, private uploadService: UploadService) {
  }

  ngOnInit(): void {
    this.bravaEnabled = Util.RestAPI.isBravaEnabled();
    this.isAddin = Util.Device.bIsAddin;
    this.isAcrobatPlugin = Util.Device.bIsAcrobatPlugin;
    this.isOfficeAddin = Util.Device.bIsOfficeAddin;
    this.isOfficeAddinOutlook = this.isOfficeAddin && !!Office && !!Office.context && !!Office.context.mailbox;
    this.isOfficeAddinOutlookMessageEditable = Util.Device.bIsOfficeAddinOutlookMessageEditable;
    this.ieEdge = Util.Device.bIsIE || Util.Device.bIsEdge;
    this.addinItemChangedEventID = Util.RestAPI.registerAddinItemChangedEvent(this.startFindAddinItem.bind(this));
    this.addinItemExtension = this.isOfficeAddinOutlook ? 'msg'
      : Util.Device.bIsOfficeAddinWord ? 'docx'
        : Util.Device.bIsOfficeAddinExcel ? 'xlsx'
          : Util.Device.bIsOfficeAddinPowerPoint ? 'pptx'
            : this.isAcrobatPlugin ? 'pdf' : '';
    setTimeout(() => {
      this.startFindAddinItem();
    }, 500);
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (!!changes && !!changes['isUploadToEdocsClicked'] && !changes['isUploadToEdocsClicked'].isFirstChange()) {
      this.startFindAddinItem();
    }
  }

  ngOnDestroy(): void {
    this.gotOfficeDataFiles.emit(false);
    Util.RestAPI.deRegisterAddinItemChangedEvent(this.addinItemChangedEventID);
  }

  private canShowPreview(): boolean {
    return Util.RestAPI.canShowPreview();
  }

  private canShowSecurity(): boolean {
    if (!!this.addinItem) {
      const rights: SecurityControl = new SecurityControl(AccessLevel.ACCESS_LEVEL_FULL);
      if (!!this.addinItem['%SECURITY']) {
        const itemAccess = +this.addinItem['%SECURITY'];
        if (itemAccess > 0) {
          rights.access &= itemAccess;
        }
      }
      return rights.canControlAccess;
    }
    return false;
  }

  private isDocumentInIcOrDmTempLocation(temp?: string): boolean {
    temp = !!temp ? temp.toUpperCase() : 'ICTEMP';
    const sep = Util.Device.bIsWindows ? '\\' : '/';
    const tempDirectorySuffix = 'OPENTEXT' + sep + 'DM' + sep + temp + sep;
    if (!!this.addinItemFilePath && this.addinItemFilePath.toUpperCase().indexOf(tempDirectorySuffix) !== -1) {
      return true;
    }
    return false;
  }

  private showSaveButton(): boolean {
    if (!this.findingAddinItem && (!this.addinItem && this.addEnabled) || !!this.addinItem) {
      return !this.isDocumentInIcOrDmTempLocation('TEMP');
    }
    return false;
  }

  private canShowSaveAsDmVersion(): boolean {
    const allowSaveAsDmVersion = (Util.RestAPI.getSystemDefaultSetting('ALLOW_SAVE_AS_DM_VERSION') || 'N').toUpperCase() === 'Y';
    return allowSaveAsDmVersion && !this.addinItem && !Office?.context?.mailbox;
  }

  private saveButtonTitle(): string {
    return this.localizer.getTranslation('FORMS.BUTTONS.' + (!!this.addinItem ? 'SAVE_AS' : 'SAVE'));
  }

  private extractTrusteesFromProfileData(profileData: any): any[] {
    let trustees: any[] = null;
    if (!!profileData['edx_trustees']) {
      trustees = profileData['edx_trustees'];
      delete profileData['edx_trustees'];
    } else {
      this.trustees = null;
    }
    return trustees;
  }

  private extractFileFormInfoFromProfileData(profileData: any): FileFormInfo {
    let ffi: FileFormInfo = null;
    if (!!profileData['edx_fileFormInfo']) {
      ffi = profileData['edx_fileFormInfo'];
      delete profileData['edx_fileFormInfo'];
    } else {
      this.fileFormInfo = null;
    }
    return ffi;
  }

  private startFindOutlookItem(): void {
    const outlookMailbox = this.isOfficeAddin && Office && Office.context ? Office.context.mailbox : null;
    const outlookItem = outlookMailbox ? outlookMailbox.item : null;
    if (!!outlookItem?.getSharedPropertiesAsync) {
      outlookItem.getSharedPropertiesAsync((result) => {
        outlookMailbox['sharedProperties'] = result['value'];
        Util.RestAPI.setOutlookMailbox(outlookMailbox);
      });
    } else {
      Util.RestAPI.setOutlookMailbox(outlookMailbox);
    }
    const notFound = () => {
      Util.RestAPI.getOutlookItemProfileData(outlookMailbox, null, true, this.getCurDesc()).then(profileData => {
        const nAttach: number = outlookItem.attachments ? outlookItem.attachments.length : 0;
        const fileName: string = this.addinItemTitle + '.msg';
        this.addinItemAttachments = outlookItem.attachments && outlookItem.attachments.length > 0 ? outlookItem.attachments : null;
        this.dataFiles = [{ name: fileName, url: 'promise_msg', attachNum: null }];
        if (this.addinItemAttachments) {
          for (let i = 0; i < nAttach; i++) {
            if (this.addinItemAttachments[i].isInline === false) {
              this.dataFiles[0]['attachNum'] = -1;
              break;
            }
          }
        }
        this.desc = this.getCurDesc(fileName);
        this.trustees = this.extractTrusteesFromProfileData(profileData);
        this.fileFormInfo = this.extractFileFormInfoFromProfileData(profileData);
        this.formData = profileData;
        if (this.addinItemAttachments) {
          this.addinItemOptionItems = [];
          this.addinItemOptionItems.push({ value: 'M', display: this.localizer.getTranslation('FORMS.LOCAL.OAI_ADD.MSG_ATTACHMENTS') });
          if (!!Office.context.mailbox.restUrl || !!Office.context.mailbox.ewsUrl) {
            this.addinItemOptionItems.push({ value: 'E', display: this.localizer.getTranslation('FORMS.LOCAL.OAI_ADD.EXCLUDE_ATTACHMENTS') });
          }
          this.addinItemOptionItems.push({ value: 'S', display: this.localizer.getTranslation('FORMS.LOCAL.OAI_ADD.MSG_ATTACHMENTS_SEPARATELY') });
          this.addinItemOptionItems.push({ value: 'ALL', display: this.localizer.getTranslation('FORMS.LOCAL.OAI_ADD.ALL') });
          this.addinItemOption = 'M';
        } else if (!!Office.context.mailbox.restUrl || !!Office.context.mailbox.ewsUrl) {
          this.addinItemOptionItems = [{ value: 'E', display: this.localizer.getTranslation('FORMS.LOCAL.OAI_ADD.EXCLUDE_ATTACHMENTS') }];
          this.addinItemOption = 'E';
          this.dataFiles[0]['excludeAttachments'] = true;
        }
        this.gotOfficeDataFiles.emit(true);
        this.findingAddinItem = false;
      });
    };
    const findNewItem = () => {
      this.formData = null;
      this.dataFiles = null;
      this.addinItemOption = null;
      this.gotOfficeDataFiles.emit(false);
      if (outlookItem && outlookItem.internetMessageId) {
        this.findingAddinItem = true;
        this.addinItem = null;
        Util.Device.officeDMItem = null;
        this.addinItemTitle = outlookItem.subject;
        //DMIC-7460 Using regex expression to replace the emoticons in the subject with ''
        this.addinItemTitle = this.addinItemTitle.replace(/(\u00a9|\u00ae|[\u2000-\u3300]|\ud83c[\ud000-\udfff]|\ud83d[\ud000-\udfff]|\ud83e[\ud000-\udfff]|\ufe0f)/g, '');
        Util.RestAPI.getCurrentOutlookExistingListItem(outlookItem).then(listItem => {
          this.addinItem = listItem;
          Util.Device.officeDMItem = this.addinItem;
          this.findingAddinItem = false;
        }, notFound);
      } else {
        notFound();
      }
    };
    if (!!outlookMailbox) {
      this.zone.run(findNewItem);
    }
  }

  private getCurDesc(fileName?: string): any {
    if (!!this.desc) {
      this.desc['name'] = fileName ?? this.desc['name'];
      return this.desc;
    }
    return { id: '', lib: Util.RestAPI.getPrimaryLibrary(), type: 'documents', name: fileName ?? this.addinItemTitle };
  }

  private startFindAddinItem(): void {
    const notFound = () => {
      this.addinItemTitle = this.addinItemTitle || '';
      let nameParts: string[] = this.addinItemTitle.split('.');
      if (nameParts.length > 1) {
        nameParts.splice(nameParts.length - 1);
      }
      this.addinItemTitle = nameParts.join('.');
      if (this.addinItemTitle.startsWith('http')) {
        nameParts = this.addinItemTitle.split('/');
        this.addinItemTitle = nameParts[nameParts.length - 1];
      }
      this.findingAddinItem = false;
      this.addinItemExtension = this.getFileExtension();
      if (!!Office?.context?.document) {
        this.dataFiles = [{ name: this.addinItemTitle + '.' + this.addinItemExtension, officeDoc: Office.context.document, url: this.addinItemFilePath }];
      } else if (this.isAcrobatPlugin) {
        const acrobatItem = Util.getAcrobatPluginObject();
        this.dataFiles = [{ name: this.addinItemTitle + '.' + this.addinItemExtension, officeDoc: acrobatItem, url: acrobatItem.FileName }];
      } else {
        this.dataFiles = [{ name: this.addinItemTitle + '.docx', b64Data: btoa('A fake document') }];
      }
      this.desc = this.getCurDesc(this.dataFiles[0].name);
      this.addinItemOptionItems = [{ value: 'D', display: this.localizer.getTranslation('FORMS.LOCAL.OAI_ADD.DEFAULT') }];
      if (!this.officePropertiesError && (Util.Device.bIsOfficeAddinDesktop || Util.Device.bIsOfficeAddinWord)) {
        this.addinItemOptionItems.push({ value: 'P', display: this.localizer.getTranslation('FORMS.LOCAL.OAI_ADD.PDF') });
      }
      if (Util.Device.bIsOfficeAddinWord) {
        const appID: string = Util.RestAPI.getAppIDForFile('tmp.txt', null);
        if (!!appID) {
          this.addinItemOptionItems.push({ value: 'T', display: this.localizer.getTranslation('FORMS.LOCAL.OAI_ADD.TEXT') });
        }
      }
      this.addinItemOption = 'D';
      Util.RestAPI.getFormInfoForFile(this.dataFiles[0].name, Util.RestAPI.getPrimaryLibrary()).then((ffi: FileFormInfo) => {
        const formName = !!ffi.defForm ? ffi.defForm : Util.RestAPI.getDefaultProfileForm().id;
        const formIndex: number = ffi.forms.indexOf(formName);
        if (formIndex >= 0) {
          this.formData = Util.deepCopy(ffi.profile_defaults[formIndex]);
          this.formData['FORMNAME'] = formName;
          this.trustees = ffi.trustees[formIndex];
          this.fileFormInfo = Util.deepCopy(ffi);
        }
        this.gotOfficeDataFiles.emit(true);
      });
    };
    const documentRecognized = (document) => {
      const parentAddinItem = Util.RestAPI.getAddinItem();
      this.addinItem = document;
      Util.RestAPI.get(this.addinItem, 'profile').subscribe(profileData => {
        this.addinItem = { ...this.addinItem, ...profileData };
        this.addinItem['MATTER_NAME'] = profileData['MATTER_NAME'] || profileData['X8809'] || '';
        this.addinItem['CLIENT_NAME'] = profileData['CLIENT_NAME'] || profileData['X7316'] || '';
        if (!!this.addinItem) {
          if (!this.addinItem['vers']) {
            this.addinItem['vers'] = this.addinItemVersionLabel;
          }
          Util.RestAPI.get(this.addinItem, 'versions').subscribe(result => {
            const currentVersion = result?.['list'].find(version => version['VERSION_LABEL'] === this.addinItem['vers']);
            this.addinItem['VERSION_COMMENTS'] = currentVersion?.['COMMENTS'];
            this.addinItem['VERSION_STATUS'] = currentVersion?.['STATUS'];
            Util.RestAPI.setAddinItem(this.addinItem);
            Util.Device.officeDMItem = this.addinItem;
            // Forcing office to update footer when it opens it up
            if (this.formService.formUpdatedSuccessfully === undefined && this.ooxmlService.isAlwaysUpdateFooterEnabled()) {
              // Get profile data for footer update to have more metadata
              if (!!this.addinItem['checkout']) {
                this.ooxmlService.addFooter(this.addinItem, true).then(() => {
                  this.formService.formUpdatedSuccessfully = false;
                }, footerError => {
                  console.log(footerError);
                });
              }
            } else if (Util.Device.bIsOfficeAddinWord) {
              const isDocumentAndVersionUnchanged = !!parentAddinItem && Util.RestAPI.isSameDesc(parentAddinItem, this.addinItem) && parentAddinItem['vers'] === this.addinItem['vers'];
              if (this.ooxmlService.isAlwaysUpdateFooterEnabled()) {
                this.ooxmlService.addFooter(this.addinItem, true).then(() => {
                }, footerError => {
                  console.log(footerError);
                });
              } else if (!isDocumentAndVersionUnchanged) {
                this.ooxmlService.addFooter(this.addinItem, false, true).then(() => {
                }, footerError => {
                  console.log(footerError);
                });
              }
            }
          });
        }
      });
      this.findingAddinItem = false;
      this.desc = null;
    };
    const searchForDoc = (docNum: string, lib: string): void => {
      const searchCriteria: any = {};
      const criteria: any = {};
      const searchForms: any[] = Util.RestAPI.getSearchForms();
      if (searchForms && searchForms.length) {
        searchCriteria['FORM_NAME'] = searchForms[0]['%FORM_NAME'];
      }
      searchCriteria['DESCRIPTION'] = docNum;
      criteria['DOCNUM'] = docNum;
      searchCriteria['criteria'] = criteria;
      this.addinItem = null;
      Util.Device.officeDMItem = null;
      this.findingAddinItem = true;
      const shouldRecognizeTaggedDocuments = (Util.RestAPI.getSystemDefaultSetting('RECOGNIZE_TAGGED_DOCUMENTS_AS_INTEGRATED') || 'Y').toUpperCase() === 'Y';
      const isInTempLocation = this.isDocumentInIcOrDmTempLocation();
      Util.RestAPI.post({ id: 'evaluation', lib, type: 'searches' }, searchCriteria, '', 'libs=' + lib + '&start=0&max=1&ascending=SYSTEM_ID').subscribe(async (listData: ListData) => {
        if (!!listData?.list?.length) {
          await Util.RestAPI.setFailedCheckins(listData);
          const docItem = listData.list[0];
          const isCheckedout = !!docItem.checkout;
          const launchInfo = Util.RestAPI.getCachedOfficeLaunchInfo(this.addinItemFilePath);
          if (shouldRecognizeTaggedDocuments || isInTempLocation || isCheckedout || (launchInfo?.launched === true)) {
            documentRecognized(docItem);
          } else if (!launchInfo) {
            Util.RestAPI.getPFTALaunchInfo(this.addinItemFilePath).then(pftaLaunchInfo => {
              Util.RestAPI.setCachedOfficeLaunchInfo(pftaLaunchInfo);
              if (pftaLaunchInfo?.launched) {
                documentRecognized(docItem);
              } else {
                notFound();
              }
            });
          } else {
            notFound();
          }
        } else {
          notFound();
        }
      }, err => {
        notFound();
      });

      /* DMIC-9883 - After saving document as a new version, sub version, new doc and replacement
         of the current version, document settings changes and word considers the document dirty */
      if (Util.Device.bIsOfficeAddinWord) {
        Util.RestAPI.getOfficeDocProperties().then(properties => {
          if (!properties.isReadOnly && this.isSaveButtonClicked) {
            Word.run(async (context) => {
              context.load(context.document, 'saved');
              await context.sync();
              if (context.document.saved === false) {
                context.document.save();
                await context.sync();
              }
            });
          }
        });
      }
    };
    const getFileNameDocProperty = async (done) => {
      try {
        const getDiskName = async () => {
          await Office.context.document.getFilePropertiesAsync(async asyncResult => {
            let officeFilename: string;
            let edxFileName: string = null;
            if (!!Office.context.document.settings) {
              edxFileName = Office.context.document.settings.get('edx_filename');
            }
            if (!!asyncResult && !!asyncResult.value && !!asyncResult.value.url) {
              const sep: string = (Util.Device.bIsWindows && !asyncResult.value.url.startsWith('http')) ? '\\' : '/';
              const components: string[] = asyncResult.value.url.split(sep);
              officeFilename = components[components.length - 1];
              this.addinItemFilePath = asyncResult.value.url;
              done(officeFilename, edxFileName);
            } else if (!!asyncResult && !!asyncResult.error) {
              this.officePropertiesError = asyncResult.error;
              if (Util.Device.bIsOfficeAddinExcel && asyncResult.error.code === 5004) {
                const waitForCellExit = () => {
                  Util.Notify.confirm(this.localizer.getTranslation('GENERIC_ERRORS.ERROR'), this.localizer.getTranslation('FORMS.LOCAL.OAI_ADD.EXCEL_5004'), null, null, false, true, true).then(response => {
                    if (response && response.confirm) {
                      getDiskName();
                    } else {
                      setTimeout(waitForCellExit, 1000);
                    }
                  });
                };
                waitForCellExit();
              } else {
                done(officeFilename, edxFileName);
              }
            } else {
              done(officeFilename, edxFileName);
            }
          });
        };
        getDiskName();
      } catch {
        done();
      }
    };

    const startFindAcrobatItem = async () => {
      const acrobatItem = Util.getAcrobatPluginObject();
      const pathParts = Util.Transforms.splitPath(acrobatItem.FileName);
      const fileName = pathParts.fullFileName;
      const diskFileNameIsManagedFile = Util.Transforms.isDMManagedFile(fileName);
      this.addinItemFilePath = acrobatItem.FileName;
      this.addinItemTitle = this.addinItemFileName = fileName;
      this.addinItemVersionLabel = null;
      if (diskFileNameIsManagedFile) {
        const docObj = Util.decodeFileName(fileName);
        if (!!docObj) {
          this.addinItemTitle = docObj.name;
          this.addinItemExtension = docObj.ext || this.addinItemExtension;
          this.addinItemVersionLabel = docObj.vers;
          searchForDoc(docObj.docNum, docObj.lib);
        } else {
          notFound();
        }
      } else {
        notFound();
      }
    };

    const afterGetFileURL = async () => {
      await getFileNameDocProperty(async (officeFilename: string, edxFileName: string) => {
        const metatDataNameIsManagedFile = Util.Transforms.isDMManagedFile(edxFileName);
        const diskFileNameIsManagedFile = Util.Transforms.isDMManagedFile(officeFilename);
        if (metatDataNameIsManagedFile && diskFileNameIsManagedFile) {
          const metaDataDocObj = Util.decodeFileName(edxFileName);
          const diskFileDocObj = Util.decodeFileName(officeFilename);
          const resetDocumentTag = () => {
            Util.RestAPI.setOfficeDocCustomProperty('edx_filename', officeFilename);
            edxFileName = null;
          };
          if (!!metaDataDocObj && !!diskFileDocObj) {
            if (metaDataDocObj.lib === diskFileDocObj.lib && metaDataDocObj.docNum === diskFileDocObj.docNum && metaDataDocObj.vers !== diskFileDocObj.vers) {
              const metaDataFloatVers = Util.versionFloatFromLabel(metaDataDocObj.vers);
              const diskFileFloatVers = Util.versionFloatFromLabel(diskFileDocObj.vers);
              if (diskFileFloatVers > metaDataFloatVers) {
                resetDocumentTag();
              }
            }
            if ((metaDataDocObj.lib !== diskFileDocObj.lib) || ((metaDataDocObj.docNum >> 0) < (diskFileDocObj.docNum >> 0))) {
              resetDocumentTag();
            }
          }
        }
        const fileName = edxFileName ? edxFileName : officeFilename;
        this.zone.run(() => {
          this.addinItemTitle = this.addinItemFileName = fileName;
          this.addinItemVersionLabel = null;
          if (metatDataNameIsManagedFile || diskFileNameIsManagedFile) {
            const docObj = Util.decodeFileName(fileName);
            if (!!docObj) {
              this.addinItemTitle = docObj.name;
              this.addinItemExtension = docObj.ext || this.addinItemExtension;
              this.addinItemVersionLabel = docObj.vers;
              searchForDoc(docObj.docNum, docObj.lib);
            } else {
              notFound();
            }
          } else {
            notFound();
          }
        });
      });
    };
    const getFileURL = async (done) => {
      try {
        await Office.context.document.getFilePropertiesAsync(async asyncResult => {
          if (!!asyncResult && !!asyncResult.value && !!asyncResult.value.url) {
            done(asyncResult.value.url);
          } else {
            done(null);
          }
        });
      } catch {
        done(null);
      }
    };
    const startLooking = async () => {
      if (!!Office?.context?.mailbox) {
        this.startFindOutlookItem();
      } else if (!!Office?.context?.document) {
        await getFileURL(async (anUrl: string) => {
          afterGetFileURL();
        });
      } else if (this.isAcrobatPlugin) {
        startFindAcrobatItem();
      } else {
        // test code
        if (searchForTestDoc) {
          searchForDoc('1210', 'RHQA167-Legal');
        } else {
          this.addinItemTitle = 'Fake';
          this.addinItemFileName = 'fake.docx';
          notFound();
        }
      }
    };
    const waitForCache = () => {
      if (Util.RestAPI.cacheIsLoaded() && !!Util.RestAPI.getTiles() && Util.RestAPI.getTiles().length > 0) {
        startLooking();
      } else {
        setTimeout(() => {
          waitForCache();
        }, 500);
      }
    };
    if (this.isAcrobatPlugin || (this.isOfficeAddin && !!Office && !!Office.context)) {
      this.addinItemTitle = null;
      this.addinItemFileName = null;
      this.addinItemAttachments = null;
      this.msgAndAttachmentsList = null;
      this.showAttachmentsSelectionList = false;
      this.dataFiles = null;
      this.findingAddinItem = true;
      this.officePropertiesError = null;
      this.gotOfficeDataFiles.emit(false);
      waitForCache();
    }
  }

  private addintemName(): string {
    return this.findingAddinItem ? '...' : this.addinItem ? this.addinItem['DOCNAME'] : this.addinItemTitle;
  }

  private addinItemIcon(): string {
    const iconPath = 'assets/images/';
    let icon: string;
    if (Util.safeHasOwn(window, 'Word')) {
      icon = 'mime_word.svg';
    } else if (Util.safeHasOwn(window, 'Excel')) {
      icon = 'mime_excel.svg';
    } else if (Util.safeHasOwn(window, 'PowerPoint')) {
      icon = 'mime_powerpoint.svg';
    } else if (this.isAcrobatPlugin) {
      icon = 'mime_pdf.svg';
    } else {
      icon = 'mime_outlook.svg';
    }
    return !this.findingAddinItem && this.addinItem ? Util.Transforms.iconUrlFromDesc(this.addinItem) : (iconPath + icon);
  }

  private addintemIconAdd(): boolean {
    return !this.findingAddinItem && !this.addinItem && !!this.addinItemTitle;
  }

  private addinItemIconProfile(): boolean {
    return !this.findingAddinItem && !!this.addinItem;
  }

  private profileClick(tab: string): boolean {
    if (!this.findingAddinItem) {
      if (this.addinItem) {
        this.app.doCommand('profile_outlook_item', { list: this.addinItem, tab });
      } else if (!!Office && !!Office.context) {
        if (!!Office.context.mailbox) {
          this.app.doCommand('uploadaddintem');
        } else if (Office.context.document) {
          Office.context.document.getFileAsync(Office.FileType.Compressed, { sliceSize: 65536 }, result => {
            if (result.status === 'succeeded') {
              this.zone.run(() => {
                const file = result.value;
                const fileSize: number = file.size * 2; // this is only for progress and we are base64 encoding so double the size
                file.closeAsync();
                Util.RestAPI.uploadFilesWithUI(null, null, [{ name: this.addinItemTitle, size: fileSize, officeDoc: Office.context.document }]);
              });
            }
          });
        }
      }
    }
    return true;
  }

  private attachmentSelectionChanged(event: Event) {
    const dataFiles = [];
    for (const attData of event['selectedList']) {
      dataFiles.push({ name: attData.display, url: attData['url'], attachNum: attData['attachNum'], mailID: attData['mailID'] });
    }
    const firstAttachmentInTheList = dataFiles.length > 0 ? dataFiles[0] : null;
    let appID = null;
    const emlDataFileIndex = dataFiles.findIndex(dataFile => dataFile.url === 'promise_msg');
    const attachmentNames = [];
    if (emlDataFileIndex !== -1 && dataFiles.length !== this.msgAndAttachmentsList.length && (this.addinItemOption === 'E' || this.addinItemOption === 'S')) {
      for (const attachment of this.msgAndAttachmentsList) {
        if (dataFiles.findIndex(item => item.url === attachment.url) === -1) {
          attachmentNames.push(attachment.name);
        }
      }
      if (attachmentNames.length > 0) {
        dataFiles[emlDataFileIndex]['attachmentNames'] = attachmentNames;
      }
    }
    if (!!firstAttachmentInTheList) {
      appID = Util.RestAPI.getAppIDForFile(firstAttachmentInTheList.name || firstAttachmentInTheList.Name, this.desc?.lib);
    }
    Util.RestAPI.getOutlookItemProfileData(Office.context.mailbox, null, true, this.getCurDesc(), appID).then(profileData => {
      if (dataFiles?.length === 1) {
        profileData['DOCNAME'] = '';
      }
      this.updateDataFiles(dataFiles, this.getCurDesc(''), profileData);
    });
  }

  public updateDataFilesFromAttachments(): any {
    const dataFiles = [];
    for (let i = 0; i < this.addinItemAttachments.length; i++) {
      const attachmentData = this.addinItemAttachments[i];
      dataFiles.push({ name: attachmentData.Name || attachmentData.name, url: 'promise_' + i, attachNum: i, mailID: this.formData['MAIL_ID'] });
    }
    return dataFiles;
  }

  public updateDataFiles(newDataFiles: DataFile[], newDesc: any, newFormData: any) {
    this.descDataFilesChanging.emit(true);
    setTimeout(() => {
      this.dataFiles = newDataFiles;
      this.desc = newDesc;
      if (this.addinItemOption === 'S' || this.addinItemOption === 'ALL') {
        this.app.commandsComponent.dialogKind = 'profile';
        this.uploadService.setData(this.dataFiles, this.desc, null, true);
      } else {
        this.uploadService.resetData();
      }
      if (newFormData) {
        this.trustees = this.extractTrusteesFromProfileData(newFormData);
        this.formData = newFormData;
        this.gotOfficeDataFiles.emit(false);
        setTimeout(() => {
          // destroy the profile form then reload it with the new data
          this.gotOfficeDataFiles.emit(true);
        }, 300);
      } else {
        this.gotOfficeDataFiles.emit(true);
      }
    }, 1);
  }

  private addinItemOptionChanged(seg: SegmentComponent): void {
    if (this.isOfficeAddinOutlook) {
      this.previousSelectedAddinItemOption = this.addinItemOption;
      this.addinItemOption = seg.value;
      let attIndex: number = null;
      let descName: string = this.addinItemTitle;
      this.showAttachmentsSelectionList = false;
      const populateAttachmentsListBox = () => {
        attIndex = -1;
        this.desc = this.getCurDesc(descName);
        this.msgAndAttachmentsList = this.dataFiles.concat(this.updateDataFilesFromAttachments());
        for (const item of this.msgAndAttachmentsList) {
          item['src'] = Util.Transforms.iconUrlFromDesc({ APP_ID: Util.RestAPI.getAppIDForFile(item['name']) });
          item['display'] = item['name'];
          item['value'] = item['name'];
        }
        this.msgAndAttachmentsSelection = this.msgAndAttachmentsList.map(i => i.name).join(',');
        this.showAttachmentsSelectionList = true;
      };
      switch (this.addinItemOption) {
        case 'M':
        case 'E':
          this.dataFiles = [{ name: this.addinItemTitle + '.msg', url: 'promise_msg', attachNum: this.addinItemOption === 'E' ? null : -1, excludeAttachments: this.addinItemOption === 'E', attachmentNames: !!this.addinItemAttachments ? this.addinItemAttachments.map(att => att.name) : null }];
          this.desc = this.getCurDesc(descName);
          break;
        case 'ALL':
          this.dataFiles = [];
          populateAttachmentsListBox();
          break;
        case 'S':
          this.dataFiles = [{ name: this.addinItemTitle + '.msg', url: 'promise_msg', attachNum: -1, mailID: this.formData['MAIL_ID'], excludeAttachments: false }];
          populateAttachmentsListBox();
          break;
        default:
          attIndex = parseInt(this.addinItemOption);
          break;
      }
      if (attIndex !== null && this.addinItemAttachments) {
        let dataFiles: DataFile[] = [];
        if (this.addinItemOption === 'S') {
          dataFiles = dataFiles.concat(this.dataFiles);
        }
        const attData = attIndex >= 0 ? this.addinItemAttachments[attIndex] : this.addinItemAttachments[0];
        const appID = this.addinItemOption === 'S' ? 'MS Outlook' : Util.RestAPI.getAppIDForFile(attData.Name || attData.name, !!this.desc ? this.desc.lib : Util.RestAPI.getPrimaryLibrary());
        if (attIndex >= 0) { //TODO: Check and remove this code as having attachment separately (attIndex>=0 condition) in THIS dropdown is removed.
          descName = attData.Name || attData.name;
          dataFiles.push({ name: descName, url: 'promise_' + attIndex, attachNum: attIndex });
        } else {
          dataFiles = dataFiles.concat(this.updateDataFilesFromAttachments());
        }
        Util.RestAPI.getOutlookItemProfileData(Office.context.mailbox, null, true, this.getCurDesc(), appID).then(profileData => {
          if (dataFiles?.length === 1) {
            profileData['DOCNAME'] = descName;
          }
          this.updateDataFiles(dataFiles, this.getCurDesc(descName), profileData);
        });
      } else {
        Util.RestAPI.getOutlookItemProfileData(Office.context.mailbox, null, true, this.getCurDesc()).then((profileData) => {
          if (this.previousSelectedAddinItemOption !== 'M' && this.previousSelectedAddinItemOption !== 'E') {
            this.updateDataFiles(this.dataFiles, this.getCurDesc(descName), profileData);
          }
        });
      }
    } else {
      this.addinItemOption = seg.value;
      switch (this.addinItemOption) {
        case 'D':
          this.addinItemExtension = this.getFileExtension();
          break;
        case 'T':
          this.addinItemExtension = Util.Device.bIsOfficeAddinWord ? 'txt' : '';
          break;
        case 'P':
          this.addinItemExtension = 'pdf';
          break;
      }
      this.updateDataFiles([{ name: this.addinItemTitle + '.' + this.addinItemExtension, officeDoc: Office.context.document }], this.getCurDesc(this.addinItemExtension), null);
    }
  }

  private saveButtonClicked(event: Event, isSaveAsDMVersion?: boolean): void {
    const fileName: string = this.addinItemTitle + (this.addinItemTitle.endsWith(this.addinItemExtension) ? '' : ('.' + this.addinItemExtension));
    this.formService.formUpdatedSuccessfully = false;
    if (!this.addinItem) {
      this.addToDMClicked.emit(true);
    } else {
      const uploadNewDocument = (dataFile) => {
        const docObj: any = Util.decodeFileName(dataFile.name);
        if (!!docObj) {
          dataFile.name = docObj.name + (!!docObj.ext ? '.' + docObj.ext : '');
        }
        if (this.isOfficeAddinOutlook) {
          Util.RestAPI.getOutlookItemProfileData(Office.context.mailbox, null, true, this.getCurDesc()).then((data: any) => {
            this.extractTrusteesFromProfileData(data);
            Util.RestAPI.uploadFilesWithUI(null, null, [dataFile], null, data);
          }, e => {
            Util.RestAPI.uploadFilesWithUI(null, null, [dataFile]);
          });
        } else {
          dataFile.fromSaveAsDesc = Util.deepCopy(this.addinItem);
          const addNewDoc = () => {
            dataFile.fromSaveAsDesc.STATUS = '0';
            dataFile.fromSaveAsDesc.vers = docObj?.vers || this.addinItem.checkout?.VERSION_LABEL || '1';
            dataFile.listItemCB = listItemCB;
            Util.RestAPI.get(this.addinItem, 'profile').subscribe((data: any) => {
              Util.RestAPI.uploadFilesWithUI(null, null, [dataFile], null, data);
            }, e => {
              Util.RestAPI.uploadFilesWithUI(null, null, [dataFile]);
            });
          };
          const unlockOldDoc = () => {
            Util.RestAPI.put(this.addinItem, { '%STATUS': '%UNLOCK' }, 'profile', null, { observe: 'response' }).subscribe(addNewDoc, addNewDoc);
          };
          Util.RestAPI.cancelMonitorFile(this.addinItemFileName, this.addinItemFilePath).then(unlockOldDoc, unlockOldDoc);
        }
      };

      const isCheckedOutByMe: boolean = !!this.addinItem && this.addinItem['STATUS'] === '3' && !!this.addinItem['checkout'] && this.addinItem['checkout']['TYPIST_ID'].toUpperCase() === Util.RestAPI.getUserID();
      const isSelectedVersionSameAsCheckedOutVersionByMe = isCheckedOutByMe && this.addinItem['vers'] === this.addinItem['checkout'].VERSION_LABEL;
      const rights: SecurityControl = Util.RestAPI.getRightsForItem(this.addinItem);
      const acrobatItem = Util.getAcrobatPluginObject();
      const dataFile: DataFile =
        this.isAcrobatPlugin ? { name: fileName, officeDoc: acrobatItem, url: acrobatItem.FileName } :
          this.isOfficeAddinOutlook ? { name: fileName, url: 'promise_msg' }
            : { name: (this.addinItemFileName || fileName), officeDoc: Office.context.document, url: this.addinItemFilePath };
      const listItemCB = (item: ListItem) => {
        this.addinItem = item;
        Util.Device.officeDMItem = item;
        this.findingAddinItem = false;
      };
      if (['19', '20'].indexOf(this.addinItem['STATUS']) !== -1 || this.addinItem['READONLY'] === 'Y' || (this.addinItem['STATUS'] === '3' && (!isCheckedOutByMe || !isSelectedVersionSameAsCheckedOutVersionByMe)) || !rights.canEditContent) {
        Util.Notify.success(this.localizer.getTranslation('FORMS.LOCAL.SAVE_AS.NEW_DOCUMENT'), this.localizer.getTranslation('FORMS.LOCAL.SAVE_AS.NEW_DOCUMENT_ALERT'));
        uploadNewDocument(dataFile);
      } else {
        const title = this.localizer.getTranslation('FORMS.BUTTONS.SAVE_AS');
        this.gotOfficeDataFiles.emit(false);
        const formName = Util.kLocalFormPrefix + (isSaveAsDMVersion ? 'save_as_dm_version' : 'save_as');
        Util.Notify.confirm(title, formName, null, { list: [this.addinItem], versionLabel: this.addinItemVersionLabel }, true, true, true).then(confirmed => {
          if (confirmed && confirmed.confirm) {
            const radioVal: string = confirmed.data['$edx_save_as_radio'];
            const comment: string = confirmed.data['COMMENT'];
            const vers: string = this.addinItemVersionLabel || 'C';
            const formData: any = !!comment ? { COMMENT: comment } : {};

            const doUploadNewVers = (aVers: string): void => {
              const isReadOnlyVersion = ['19', '20'].indexOf(this.addinItem['VERSION_STATUS']) !== -1;
              const queryArgs = !isReadOnlyVersion ? 'keeplock' : '';
              if (isReadOnlyVersion) {
                dataFile.fromSaveAsDesc = Util.deepCopy(this.addinItem);
              }
              formData['_restapi'] = { src: { ver_label: vers, id: this.addinItem.id, type: this.addinItem.type, lib: this.addinItem.lib } };
              dataFile.listItemCB = listItemCB;
              Util.RestAPI.uploadDataFiles(this.addinItem, formData, [dataFile], false, aVers, queryArgs);
            };
            const cancelPFTAThenUpload = (aVers: string): void => {
              if (this.isAddin) {
                Util.RestAPI.cancelMonitorFile(this.addinItemFileName, this.addinItemFilePath).then((res) => {
                  if (!!aVers) {
                    this.addinItemVersionLabel = aVers;
                  }
                  doUploadNewVers(aVers);
                }, () => {
                  doUploadNewVers(aVers);
                });
              } else {
                doUploadNewVers(aVers);
              }
            };
            //We need to reset the filename property to be read later from Office VSTO
            Util.RestAPI.setOfficeDocCustomProperty('edx_filename', '');

            switch (radioVal) {
              case 'RV':
                Util.RestAPI.uploadDataFiles(this.addinItem, formData, [dataFile], true, vers, 'keeplock');
                break;
              case 'NV':
                cancelPFTAThenUpload(null);
                break;
              case 'NSV':
                cancelPFTAThenUpload(vers);
                break;
              case 'ND':
                uploadNewDocument(dataFile);
                break;
            }
            this.isSaveButtonClicked = true;
          } else if (isSaveAsDMVersion) {
            this.addinItem = null;
            this.gotOfficeDataFiles.emit(true);
          }
        });
      }
    }
    if (!!event) {
      event.stopPropagation();
      event.preventDefault();
    }
  }

  private saveAsDmVersion(): void {
    this.app.pickDocument((list: any[], success: boolean) => {
      if (success && !!list) {
        const selectedDocument = list[0];
        if (selectedDocument['STATUS'] === '0') {
          this.addinItem = selectedDocument;
          this.saveButtonClicked(null, true);
        } else {
          Util.Notify.warning(this.localizer.getTranslation('FORMS.LOCAL.SAVE_AS.SAVE_AS_DM_VERSION'), this.localizer.getTranslation('FORMS.LOCAL.SAVE_AS.CANNOT_SAVE_AS_NEW_VERSION'));
        }
      }
    });
  }

  private getRowId(index: number) {
    return 'edx_officerow_list_' + index;
  }

  private getNextElementId(currentIndex: number, inc: number): string {
    let nextIndex = currentIndex + inc;
    if (nextIndex === 2) {
      nextIndex = this.bravaEnabled ? 2 : nextIndex + inc;
    }
    return this.getRowId(nextIndex);
  }

  private onKeyUp(event: KeyboardEvent, tab: string, index: number) {
    let elementId;
    switch (event.key) {
      case 'Enter':
      case ' ':
        this.profileClick(tab);
        break;
      case 'ArrowDown':
        elementId = this.getNextElementId(index, 1);
        break;
      case 'ArrowUp':
        elementId = this.getNextElementId(index, -1);
        break;
    }
    if (!!elementId) {
      const element = document.getElementById(elementId);
      if (!!element) {
        element.focus();
      }
    }
  }

  private getFileExtension(): string {
    if (!!this.addinItemFileName) {
      const fileNameParts = this.addinItemFileName.split('.');
      if (!!fileNameParts && fileNameParts.length >= 2) {
        return fileNameParts.pop();
      }
    }
    return Util.Device.bIsOfficeAddinWord ? 'docx' : Util.Device.bIsOfficeAddinExcel ? 'xlsx' : Util.Device.bIsOfficeAddinPowerPoint ? 'pptx' : '';
  }

  public emailHasAttachments(): boolean {
    return this.isOfficeAddinOutlook && this.addinItemAttachments?.length > 0;
  }

  public updateDesc(desc) {
    this.desc = desc ?? {};
  }

  public doCommand(cmd: string): boolean {
    switch (cmd) {
      case 'save_as_dm_version':
        this.saveAsDmVersion();
        break;
    }
    return true;
  }
}

